import React from 'react'
import { observer } from 'mobx-react-lite'

import { WbStoresForm } from '../../WbStoresForm'
import { StoreSettingsPage } from '../StoreSettingsPage'
import { CommissionsSettings } from '../CommissionsSettings'
import { WildberriesApiSettings } from './WildberriesApiSettings'
import { WildberriesOrdersSettings } from './WildberriesOrdersSettings'
import { WildberriesPricesSettings } from './WildberriesPricesSettings'
import { WildberriesReturnsSettings } from './WildberriesReturnsSettings'
import { WildberriesSuppliesSettings } from './WildberriesSuppliesSettings'

import { useMessages } from '../../../hooks/snackbarHooks'
import { useApi, useStore } from '../../../hooks/storeHook'
import { useWbAccountOptional } from '../../../hooks/routeHooks'

import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'
import { EditStoreAccountMsDataModel } from '../../../server/mpsklad_core/Models/EditStoreAccountMsDataModel'

export const WildberriesSettingsPage =
  observer(() => {
    const api = useApi()
    const store = useStore()
    const {showSuccess} = useMessages()

    const account = useWbAccountOptional()

    const onSubmitMsData =
      async (msData: EditStoreAccountMsDataModel) => {
        try {
          const editedAccount = await api.userSync.editWbMsData(msData)
          store.syncStore.replaceStoreAccount(editedAccount)
          showSuccess('Сохранено!')
        } catch (e) {
          console.error('Failed to edit WB MS data', e)
        }
      }

    return (
      <StoreSettingsPage
        key={account?.id ?? 0}
        account={account}
        integrationType={IntegrationType.Wildberries}
        allowSuppliesSettings={true}
        onSubmitMsData={onSubmitMsData}
        ApiSettingsComponent={WildberriesApiSettings}
        OrdersSettingsComponent={WildberriesOrdersSettings}
        WarehousesSettingsComponent={WbStoresForm}
        ReturnsSettingsComponent={WildberriesReturnsSettings}
        CommissionsSettingsComponent={CommissionsSettings}
        PricesSettingsComponent={WildberriesPricesSettings}
        SuppliesSettingsComponent={WildberriesSuppliesSettings}
      />
    )
  })